import React from 'react';
import PropTypes from 'prop-types';
import { ModuleWrapper, StyledRichText } from './styles';
import { TwoThirds, Container } from '../layout';
import { useLayout } from '../layout/context';
import { consistentString } from '../../utils/content-formatting';

const SimpleRichTextBlock = ({ richText, backgroundColor }) => {
  const { insideContainer, insideTwoThirds, insideSideBar, insideHalfWidth } =
    useLayout();

  return insideSideBar ? (
    <StyledRichText
      richText={richText}
      backgroundColor={backgroundColor === 'default' ? 'grey' : backgroundColor}
      padding
    />
  ) : (
    <ModuleWrapper $backgroundColor={backgroundColor}>
      <Container $padding={!(insideHalfWidth || insideContainer)}>
        {insideTwoThirds || insideHalfWidth ? (
          <StyledRichText
            richText={richText}
            backgroundColor={backgroundColor}
            padding={backgroundColor !== 'default' && insideContainer}
          />
        ) : (
          <TwoThirds>
            <StyledRichText
              richText={richText}
              backgroundColor={backgroundColor}
              padding={backgroundColor !== 'default' && insideContainer}
            />
          </TwoThirds>
        )}
      </Container>
    </ModuleWrapper>
  );
};

/**
 * 'default' prop type is used when no selection in Contentful is made
 */
SimpleRichTextBlock.propTypes = {
  richText: PropTypes.shape({
    raw: PropTypes.string,
    references: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  backgroundColor: PropTypes.oneOf(['default', 'white', 'grey']),
};

SimpleRichTextBlock.defaultProps = {
  backgroundColor: 'white',
};
export default SimpleRichTextBlock;

export const SimpleRichTextBlockAssembly = ({ contentfulData }) => (
  <SimpleRichTextBlock
    richText={contentfulData.text}
    backgroundColor={consistentString(contentfulData.backgroundColor)}
  />
);

SimpleRichTextBlockAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
